import { Counter } from '@app/components/various/Counter';
import { Expander } from '@app/components/various/Expander';
import { getAttributeNameMap } from '@app/ducks';
import React from 'react';
import { useSelector } from 'react-redux';

interface Props {
  filterField: string;
  isExpanded: boolean;
  selectedCount: number;
  onToggleExpanded: VoidFunction;
}

export const FilterGroupContainer = ({ filterField, selectedCount, onToggleExpanded, isExpanded, children }: React.WithChildren<Props>) => {
  const attributeNameMap = useSelector(getAttributeNameMap);
  const groupTitle = attributeNameMap.get(filterField) ?? filterField;

  const counter = selectedCount > 0 ? <Counter content={selectedCount} /> : undefined;

  return (
    <Expander header={groupTitle} headerPostfix={counter} headerLevel="h3" isExpanded={isExpanded} onToggleExpanded={onToggleExpanded}>
      {children}
    </Expander>
  );
};
